(() => {
  const setupHero = (hero) => {
    if (hero.flipzyHeroCleanup) return;

    const media = hero.querySelector('.flipzy-hero__video-shell');
    if (!media) return;

    let frame;
    const update = () => {
      const heroBounds = hero.getBoundingClientRect();
      // Budget for everything above the hero plus its optional intro.
      // Document coordinates keep the first-screen layout stable after scrolling.
      const occupiedHeight = Math.ceil(
        heroBounds.top + window.scrollY + heroBounds.height - media.getBoundingClientRect().height
      );
      const value = `${occupiedHeight}px`;
      if (hero.style.getPropertyValue('--flipzy-hero-occupied-height') !== value) {
        hero.style.setProperty('--flipzy-hero-occupied-height', value);
      }
    };
    const scheduleUpdate = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleUpdate) : null;
    observer?.observe(hero);
    document.querySelectorAll('.shopify-section-group-header-group').forEach((section) => observer?.observe(section));
    window.addEventListener('resize', scheduleUpdate);
    // Also remeasure if a merchant adds, removes or moves a section above the hero.
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);
    document.addEventListener('shopify:section:reorder', scheduleUpdate);
    update();

    hero.flipzyHeroCleanup = () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('resize', scheduleUpdate);
      document.removeEventListener('shopify:section:load', scheduleUpdate);
      document.removeEventListener('shopify:section:unload', scheduleUpdate);
      document.removeEventListener('shopify:section:reorder', scheduleUpdate);
      delete hero.flipzyHeroCleanup;
    };
  };

  const setupHeroes = (root = document) => root.querySelectorAll('.flipzy-hero').forEach(setupHero);
  setupHeroes();
  document.addEventListener('shopify:section:load', (event) => setupHeroes(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.flipzy-hero').forEach((hero) => hero.flipzyHeroCleanup?.());
  });
})();
